
module.exports = {
    REQUEST_MESSAGE: 'REQUEST_MESSAGE',
    RECEIVE_MESSAGE: 'RECEIVE_MESSAGE',
    REQUEST_MESSAGE_FAILURE: 'REQUEST_MESSAGE_FAILURE',

    REQUEST_MESSAGES: 'REQUEST_MESSAGES',
    RECEIVE_MESSAGES: 'RECEIVE_MESSAGES',
    REQUEST_MESSAGES_FAILURE: 'REQUEST_MESSAGES_FAILURE',

    SET_MESSAGE: 'SET_MESSAGE',
    CLEAR_MESSAGE: 'CLEAR_MESSAGE',

    CHANGE_SUBJECT_TEXT: 'CHANGE_SUBJECT_TEXT',
    CHANGE_SUBJECT_IMAGE: 'CHANGE_SUBJECT_IMAGE',
    CHANGE_TITLE: 'CHANGE_TITLE',
    ADD_TAG: 'ADD_TAG',
    REMOVE_TAG: 'REMOVE_TAG',
    CHANGE_TEXT: 'CHANGE_TEXT',
    CHANGE_ACTION_IMAGE: 'CHANGE_ACTION_IMAGE',
    CHANGE_ACTION_TARGET: 'CHANGE_ACTION_TARGET',
    ADD_TARGET: 'ADD_TARGET',
    REMOVE_TARGET: 'REMOVE_TARGET',
    CHANGE_TARGET: 'CHANGE_TARGET',
    CHANGE_SEND_PUSH: 'CHANGE_SEND_PUSH',
    CHANGE_PUSH_TEXT: 'CHANGE_PUSH_TEXT',
    CHANGE_PUSH_LINK: 'CHANGE_PUSH_LINK',

	MESSAGE_CREATE_REQUEST: 'MESSAGE_CREATE_REQUEST',
    MESSAGE_CREATE_SUCCESS: 'MESSAGE_CREATE_SUCCESS',
    MESSAGE_CREATE_FAILURE: 'MESSAGE_CREATE_FAILURE',

    MESSAGE_EDIT_REQUEST: 'MESSAGE_EDIT_REQUEST',
    MESSAGE_EDIT_SUCCESS: 'MESSAGE_EDIT_SUCCESS',
    MESSAGE_EDIT_FAILURE: 'MESSAGE_EDIT_FAILURE',

    VALIDATION_MESSAGE_ERROR: 'VALIDATION_MESSAGE_ERROR',
    CLEAR_MESSAGE_ERROR: 'CLEAR_MESSAGE_ERROR'
};



// WEBPACK FOOTER //
// ./src/common/modules/message-center/constants.js